import { FC } from "react";
import { Container } from "reactstrap";

type FiltersProps = {
  filters: any;
  onApply: any;
  onClear: any;
  onChange?: any;
};

const Filters: FC<FiltersProps> = ({ filters, onApply, onClear, onChange }) => {
  return <Container></Container>;
};

export default Filters;